import { useContext } from "react";
import {EditRounded, SaveRounded} from "@mui/icons-material";
import { IconButton, Grid, Typography } from "@mui/material";
import {useParams} from "react-router-dom";
import {SET_SNACKBAR} from "../../../../../common/utils";
import {GlobalContext} from "../../../../../../../util/state/GlobalContextProvider";
import {setSnackbar} from "../../../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../../../util/state/globalVariables";
import {NetworkScope} from "../../../../../types";
import {useHasScope} from "../../../../../../../config/globalConfig";
import { useTranslation } from "react-i18next";
import { IEditSaveButton } from "./types";

function EditSaveButton <CurTimeframe>({timeframe, timeframeReqField, disabled, setDisabled, setTimeframe, createTimeframe, title}: IEditSaveButton<CurTimeframe>)  {
    const {t} = useTranslation(["network", "translation"]);
    const params: any = useParams();
    const {dispatchGlobalData} = useContext(GlobalContext);
    const hasScope = useHasScope;

    const checkHours = (array: any) => {
        return array.every((obj: any) => {
            if (obj.isOpen === true) {
                return obj.opening !== null && obj.closing !== null;
            }
            if (obj.isOpen === false) {
                return obj.opening === null && obj.breakFrom === null && obj.breakTo === null && obj.closing === null;
            }
            // se il valore di isOpen non è nè true nè false, la funzione restituirà false
            return false;
        });
    }

    const showStatusGeneral = () => {
        if (checkHours(timeframe)) {
            const reqParams = {
                id: params.id,
                [timeframeReqField]: timeframe
            }
            
            createTimeframe(reqParams)
                .then((response: any) => {
                    setDisabled(true);
                    setTimeframe(response[timeframeReqField]);
                })
                .catch(() => { dispatchGlobalData(SET_SNACKBAR.ERROR) })
            return;
        }
        
        dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message: t('rsDetail.timeframe.message.error.invalidState'),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
    }

    const Edit = () =>
        <IconButton color="accent" onClick={() => setDisabled(!disabled)}>
            <EditRounded/>
        </IconButton>;

    const Save = () =>
        <IconButton color="accent" onClick={showStatusGeneral}>
            <SaveRounded/>
        </IconButton>;

    return (
        <Grid container direction="row" alignItems="start" columnSpacing={2} marginTop={4} marginBottom={2}>
            <Grid item xs={10}>
                <Typography variant="h6">
                    {t(title)}
                </Typography>
            </Grid>
            <Grid item xs={2} sx={{display: 'flex'}} justifyContent="flex-end" alignItems="flex-end">
                {hasScope(NetworkScope.MsMng) && disabled ? <Edit /> : <Save />}
            </Grid>
        </Grid>
    )
}

export default EditSaveButton;
